import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper, Polygon } from "google-maps-react";
import "./MapContainer.scss";
import { drawCircle, pin, focusPin } from "assets/helpers";
import myLocation from "../../assets/img/myLocation.png";
import user from "../../assets/img/userLocation.png";
import ReactTooltip from "react-tooltip";

export class mapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            lastMapCenter: null,
            centerAroundCurrentLocation: false,
            location: false,
            displayMarkerLocation: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        demoAsyncCall().then(() => this.setState({ loading: false }));
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.selectedEstabelecimento !==
            prevProps.selectedEstabelecimento &&
            this.props.selectedEstabelecimento
        ) {
            this.props.setIsSeenOnMap(true);
        }
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return (
    //         this.props.estabelecimentos !== nextProps.estabelecimentos ||
    //         this.props.userLocation !== nextProps.userLocation ||
    //         this.props.selectedEstabelecimento !==
    //             nextProps.selectedEstabelecimento ||
    //         this.state !== nextState ||
    //         this.props.isSeenOnMap !== nextProps.isSeenOnMap ||
    //         this.props.zoom !== nextProps.zoom
    //     );
    // }

    selectEstabelecimento(estabelecimento) {
        const { setSelectedEstabelecimento, setModal } = this.props;
        setSelectedEstabelecimento(estabelecimento);
        setModal(estabelecimento);
    }

    closePolygon = () => {
        this.props.setIsSeenOnMap(false);
        this.props.filtrar(null);
        this.props.setSelectedEstabelecimento(null);
    };

    displayMarkerLocation = () => {
        const {
            userLocation
        } = this.props;
        return (
            <Marker
                onMouseover={this.onMouseoverMarker}
                name={"Current location"}
                icon={user}
                animation={this.props.google.maps.Animation.DROP}
                initialCenter={userLocation}
                position={userLocation}
            />
        );
    }

    displayMarkers = () => {
        const {
            estabelecimentos,
            selectedEstabelecimento,
            setZoom
        } = this.props;

        const { loading } = this.state;

        if (loading) {
            return (
                <div className="sk-cube-grid2">
                    <div className="sk-cube-box">
                        <div className="sk-cube sk-cube1"></div>
                        <div className="sk-cube sk-cube2"></div>
                        <div className="sk-cube sk-cube3"></div>
                        <div className="sk-cube sk-cube4"></div>
                        <div className="sk-cube sk-cube5"></div>
                        <div className="sk-cube sk-cube6"></div>
                        <div className="sk-cube sk-cube7"></div>
                        <div className="sk-cube sk-cube8"></div>
                        <div className="sk-cube sk-cube9"></div>
                    </div>
                </div>
            );
        }

        return estabelecimentos
            ? estabelecimentos.map(estabelecimento => {
                const estabelecimentoLatLng = {
                    lat: estabelecimento.LATITUDE,
                    lng: estabelecimento.LONGITUDE
                };
                const isFavorite =
                    this.props.estabelecimentosFavoritos.find(
                        el => el.ID === estabelecimento.ID
                    ) !== undefined;

                if (selectedEstabelecimento === estabelecimento) {
                    return (
                        <Marker
                            // animation={this.props.google.maps.Animation.BOUNCE}
                            key={estabelecimento.ID}
                            id={estabelecimento.ID}
                            position={estabelecimentoLatLng}
                            icon={focusPin(
                                estabelecimento.NOVA_CATEGORIA,
                                true,
                                isFavorite
                            )}
                            onClick={() => {
                                setZoom(17);
                                this.selectEstabelecimento(estabelecimento);
                            }}
                            zIndex={
                                selectedEstabelecimento !== estabelecimento
                                    ? -1
                                    : 10001
                            }
                        />
                    );
                } else {
                    return (
                        <Marker
                            key={estabelecimento.ID}
                            id={estabelecimento.ID}
                            position={estabelecimentoLatLng}
                            icon={pin(
                                estabelecimento.NOVA_CATEGORIA,
                                true,
                                isFavorite
                            )}
                            onClick={() => {
                                setZoom(17);
                                this.selectEstabelecimento(estabelecimento);
                            }}
                            zIndex={
                                selectedEstabelecimento !== estabelecimento
                                    ? -1
                                    : 10001
                            }
                        />
                    );
                }
            })
            : null;
    };

    onDragend(mapProps, map) {
        // console.log("lat:" + map.center.lat(), "lng:" + map.center.lng());
        this.props.setIsSeenOnMap(false);
        this.setState(
            {
                lastMapCenter: { lat: map.center.lat(), lng: map.center.lng() }
            },
            () => {
                if (this.props.selectedEstabelecimento)
                    this.props.setSelectedEstabelecimento(null);
                this.props.onMapMove({
                    lat: map.center.lat(),
                    lng: map.center.lng()
                });
                //this.displayMarkers();
            }
        );

    }

    drawCircleOver(selectedEstabelecimento) {
        let outerbounds = [
            { lat: 85, lng: 180 },
            { lat: 85, lng: 90 },
            { lat: 85, lng: 0 },
            { lat: 85, lng: -90 },
            { lat: 85, lng: -180 },
            { lat: 0, lng: -180 },
            { lat: -85, lng: -180 },
            { lat: -85, lng: -90 },
            { lat: -85, lng: 0 },
            { lat: -85, lng: 90 },
            { lat: -85, lng: 180 },
            { lat: 0, lng: 180 },
            { lat: 85, lng: 180 }
        ];

        return (
            <Polygon
                strokeColor={"#000000"}
                strokeOpacity={0.5}
                strokeWeight={1}
                fillColor={"#000000"}
                fillOpacity={0.5}
                paths={[
                    outerbounds,
                    drawCircle(
                        {
                            lat: selectedEstabelecimento.LATITUDE,
                            lng: selectedEstabelecimento.LONGITUDE
                        },
                        0.05,
                        -1
                    )
                ]}
                zIndex={999999}
            />
        );
    }

    handleClick() {
        this.props.onMapMove(this.props.userLocation);
        this.setState({ lastMapCenter: this.props.userLocation });
        this.setState({ centerAroundCurrentLocation: true });
    }

    render() {
        const {
            selectedEstabelecimento,
            zoom,
            setZoom,
            userLocation,
        } = this.props;
        //console.log(zoom);
        const { lastMapCenter } = this.state;
        const stylesOptions = [
            {
                featureType: "poi.business",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.school",
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            }
        ];

        return (
            <Map
                google={this.props.google}
                zoom={zoom}
                initialCenter={userLocation}
                onDragend={this.onDragend.bind(this)}
                centerAroundCurrentLocation={true}
                center={
                    this.props.isSeenOnMap
                        ? {
                            lat: selectedEstabelecimento.LATITUDE,
                            lng: selectedEstabelecimento.LONGITUDE
                        }
                        : lastMapCenter
                }
                onReady={(props, map, e) => {
                    this.setState({
                        lastMapCenter: {
                            lat: map.center.lat(),
                            lng: map.center.lng()
                        }
                    });
                }}
                styles={stylesOptions}
            >
                {this.props.isSeenOnMap
                    ? this.drawCircleOver(selectedEstabelecimento)
                    : null}

                {this.displayMarkers()}
                {this.displayMarkerLocation()}

                {this.props.isSeenOnMap ? (
                    <div
                        className="closePolygon"
                        onClick={() => {
                            setZoom(14);
                            this.closePolygon();
                            this.props.setSelectedMkr(null)
                        }}

                    >
                        Fechar
                    </div>
                ) : null}
                <div className="myLocation"
                    onClick={() => {
                        setZoom(16);
                        this.handleClick();
                    }}
                >
                    <ReactTooltip effect="float" />
                    <img
                        src={myLocation}
                        alt="Minha localização"
                        className="myLocationBtn"
                        data-tip="Minha localização"
                    />
                </div>
            </Map>
        );
    }
}

function demoAsyncCall() {
    return new Promise(resolve => setTimeout(() => resolve(), 10000));
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyBdSyty6Gbel9DbMjasIZ3mrGLb43HrW1w"
})(mapContainer);
